import { createContext } from 'react';

import { HistogramChartConfiguration } from '../types/histogram-props.js';

export const HistogramInteractionsContext = createContext<
  NonNullable<HistogramChartConfiguration['interactions']>
>({});
